import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useRemoveAddonSubscription = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (subscriptionId: string) =>
      subscriptionService.removeAddonSubscription(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationSubscription'] });
      queryClient.invalidateQueries({ queryKey: ['addonSubscriptions'] });
      queryClient.invalidateQueries({ queryKey: ['totalIncludedSeats'] });
      queryClient.invalidateQueries({ queryKey: ['activeSeats'] });
      toast.success(tActionMessages.addonRemovedSuccessfully);
    },
  });
};

export const getRemoveAddonErrorMessage = (error: any): string => {
  return error?.response?.errors?.[0]?.message || 'Failed to remove addon';
};
